import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useNavigate, useLocation } from "react-router-dom";
import "react-bootstrap-typeahead/css/Typeahead.css";
import trasportApi from "../../api/trasportApi";
import moment from "moment";
import Select from "react-select";
import PubSub from "pubsub-js";
import Main from "../layout/Main";
import Helmet from "react-helmet";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";

const SupplierEdit = (props) => {
  let fnYear;
  const location = useLocation();
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState({});
  const [financialYearOption, setOptionFinancialYear] = useState({});

  const [clientData, setClientData] = useState(location.state ? location.state : {});
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [whatsappError, setWhatsappError] = useState("");
 
      
  // const handleCourses = (selectedCourses) => {
  //   setSelectedCourses(selectedCourses);
    
  // };
  useEffect(() => {
    const fetchData = async () => {
      
      const fnYear = await trasportApi.fetchAllFinancialYears();
  
      if (fnYear && fnYear.length) {
        let ar = [];
        //eslint-disable-next-line
        fnYear.map((item) => {
          var obj = {};
          obj.value = item.id;
          obj.label = item.name;
          ar.push(obj);
        });
        if (location?.state) {
          let acc = ar.filter((acc) => acc.value === location.state.financial_year_id);
          setSelectedFinancialYear(acc);
        }
        // // Check if the current year matches any option
        // const currentYear = new Date().getFullYear();
        // const defaultOption = ar.find(option => option.label === currentYear.toString());

        // if (defaultOption) {
        // setSelectedFinancialYear([defaultOption]); // Set the default selected option
        // }
        setOptionFinancialYear(ar);
      } else {
        setOptionFinancialYear([]);
      }
    };
  
    fetchData();
  }, []);
  
 
  const handleChange = (e) => {
    const { name, value } = e.target;
  
    // Validation rules
    const gstRegex = /^\d{2}[A-Z]{5}\d{4}[A-Z]\d[Z][A-Z\d]$/; // GST format (08ABCDE9999F1Z8)
    const eccRegex = /^[A-Z]{5}\d{4}[A-Z]XM001$/; // ECC format (ABCDE1234HXM001)
    const tinRegex = /^\d{2}[A-Z0-9]{8}$/; // TIN format (27XXXXC0001)
  
    // Check and set errors based on validation
    // if (name === "gst_no" && !gstRegex.test(value)) {
    //   setWhatsappError("Invalid GST number. Format: 08ABCDE9999F1Z8");
    // } else if (name === "ecc_no" && !eccRegex.test(value)) {
    //   setPhoneError("Invalid ECC number. Format: ABCDE1234HXM001");
    // } else if (name === "tin_no" && !tinRegex.test(value)) {
    //   setEmailError("Invalid TIN number. Format: 27XXXXC0001");
    // } else {
    //   // Clear errors if input is valid
    //   if (name === "gst_no") {
    //     setWhatsappError("");
    //   } else if (name === "ecc_no") {
    //     setPhoneError("");
    //   } else if (name === "tin_no") {
    //     setEmailError("");
    //   }
    // }
  
    // Update the state
    setClientData({ ...clientData, [name]: value });
  };
  
  
  const checkRequiredFields = () => {
    if (clientData.client_name &&
      clientData.email &&
      clientData.phone &&
      clientData.city &&
      clientData.address &&
      clientData.financial_year_id &&
      clientData.district &&
      clientData.state &&
      clientData.country &&
      clientData.pincode &&
      clientData.pan_number &&
      clientData.gst_no &&
      clientData.tin_no &&
      clientData.ecc_no) {
      return false;
    }
    return true;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
   

    if (checkRequiredFields() ) {// ||emailError ||phoneError || whatsappError 
      setValidated(true);
      return;
    }

    let result2 = {};

    if (clientData.id) {
      result2 = await trasportApi.saveClient(clientData);
      if (result2.success) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record Updated successfully' });
        navigate(`/clients/${clientData.id}`, { state: clientData });
      }
    } else {
      // console.log("Create Time Item =>",clientData)
      result2 = await trasportApi.createClient(clientData);
      if (result2?.id) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record saved successfully' });
        navigate(`/clients/${clientData.id}`, { state: result2 });
      } else {
        PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record ERROR', message: result2.errors[0].msg });
      }
    }

  };

  const handleCancel = () => {
    if (location.state?.id) {
      navigate("/clients/" + clientData.id, {state: clientData,});
    } else {
      navigate("/clients/");
    }
  };

  const handlefinancialYear = (e) => {
    setSelectedFinancialYear(e);
    setClientData({ ...clientData, financial_year_id: e.value });
  };

  return (
    <Main>
      <>
        <Helmet>
        <title>{LIST_TAB_TITLE.ClientListEdit}</title>
        </Helmet>
      </>
      <Container className="view-form">
        <Row>
          <Col></Col>
          <Col lg={8}>
            <Form
              className="mt-3"
              onSubmit={handleSubmit}
              noValidate
              validated={validated}
            >
              <Row className="view-form-header align-items-center">
                <Col lg={3}>Edit Client Master</Col>
                <Col lg={9} className="d-flex justify-content-end">
                  <Button className="btn-sm mx-2" onClick={handleSubmit}>
                    Save
                  </Button>
                  <Button
                    className="btn-sm"
                    variant="danger"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
              <Row>
              <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                    Financial Year
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Financial Year"
                      value={selectedFinancialYear}
                      onChange={handlefinancialYear}
                      options={financialYearOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Financial Year.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                       Client Name
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="client_name"
                      placeholder="Enter client Name"
                      value={clientData.client_name}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Email
                    </Form.Label>
                    <Form.Control
                      required
                      type="email"
                      name="email"
                      placeholder="Enter Your Email"
                      value={clientData.email}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Phone
                    </Form.Label>
                    <Form.Control
                      type="phone"
                      name="phone"
                      placeholder="Enter Your Phone"
                      value={clientData.phone}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      City
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="city"
                      placeholder="Enter Your City"
                      value={clientData.city}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Address
                    </Form.Label>
                    <Form.Control
                      required
                      // type="text"
                      as="textarea"
                      name="address"
                      placeholder="Enter Your Address"
                      value={clientData.address}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>    
              </Row>
              <Row>
              <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      District
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="district"
                      placeholder="Enter District name"
                      value={clientData.district}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                 <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      State
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="state"
                      placeholder="Enter State"
                      value={clientData.state}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                     Country
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="country"
                      placeholder="Enter Country"
                      value={clientData.country}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                     Pincode
                    </Form.Label>
                    <Form.Control
                      required
                      type="number"
                      name="pincode"
                      placeholder="Enter Pincode Number"
                      value={clientData.pincode}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Pan Number
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="pan_number"
                      placeholder="Enter Pan Number"
                      value={clientData.pan_number}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col> 

                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Gst Number
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="gst_no"
                      placeholder="Enter Gst Number"
                      value={clientData.gst_no}
                      onChange={handleChange}
                      maxLength={15} 
                      pattern="\d{15}"
                      isInvalid={!!whatsappError}
                    />
                  </Form.Group>
                  <Form.Control.Feedback type="invalid">
                        {whatsappError}
                  </Form.Control.Feedback>
                </Col> 

                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Tin Number
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="tin_no"
                      placeholder="Enter Tin Number"
                      value={clientData.tin_no}
                      onChange={handleChange}
                      maxLength={11} 
                      pattern="\d{11}"
                      isInvalid={!!whatsappError}
                    />
                  </Form.Group>
                  <Form.Control.Feedback type="invalid">
                        {emailError}
                  </Form.Control.Feedback>
                </Col> 

                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Ecc Number
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="ecc_no"
                      placeholder="Enter Ecc Number"
                      value={clientData.ecc_no}
                      onChange={handleChange}
                      maxLength={15} 
                      pattern="\d{15}"
                      isInvalid={!!phoneError}
                    />
                  </Form.Group>
                  <Form.Control.Feedback type="invalid">
                        {phoneError}
                  </Form.Control.Feedback>
                </Col> 
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Remark
                    </Form.Label>
                    <Form.Control
                      type="text"
                      as="textarea"
                      name="remark"
                      placeholder="Enter a Remark"
                      value={clientData.remark}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col> 
              </Row>
              <Row></Row>
            </Form>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </Main>
  );
};
export default SupplierEdit;
